import { CellItem } from "@/components/cell/cell-item";
import { useCreatePlan } from "@/hooks/requests/plan/use-create-plan";
import { useToast } from "@/hooks/ui/use-toast";
import { recreatePlanInvalidateQueries } from "@/utils/query/invalidate";
import { IonLoading } from "@ionic/react";
import { useQueryClient } from "@tanstack/react-query";

export const RecreatePlanCell = () => {
  const queryClient = useQueryClient();
  //   const { recreatePlan, isLoading } = useRecreatePlan();
  const { updatePlanAsync, isLoading } = useCreatePlan();
  const { showError } = useToast();
  const handleRecreatePlan = async () => {
    try {
      await updatePlanAsync();
      recreatePlanInvalidateQueries(queryClient);
    } catch (error) {
      if (error instanceof Error) {
        showError(error.message);
      } else {
        showError("An unknown error occurred: " + error);
      }
    }
  };

  return (
    <>
      <IonLoading
        isOpen={isLoading}
        message={"Recreating Plan..."}
        spinner="circles"
        translucent={true}
        backdropDismiss={false}
        className="fixed top-0 left-0 w-full h-full"
      />
      <CellItem label="Recreate Plan" onClick={handleRecreatePlan} />
    </>
  );
};
